import { CoApplicantPipe } from '@hb/modules/global';
import { RenovationStoreService } from '@hb/modules/property/renovation-part/renovation-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { PropertyTypePipe } from '@hb/modules/property/renovation-part/transformer/property-type/property-type-pipe';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';
import { NextButtonComponent } from '@hb/modules/global/button';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'renovation-amount',
    templateUrl: './renovation-amount.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        ApRadioModule,
        ApAmountInputComponent,
        AdditionalInfoComponent,
        CoApplicantPipe,
        NextButtonComponent,
        PropertyTypePipe
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: RenovationStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.RENOVATION_AMOUNT }
    ]
})
export class RenovationAmountComponent extends GlobalInjectComponent<RenovationStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(RenovationStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getRenovationAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount) => this.store.setRenovationAmount(amount));
    }
}
